import { createFileRoute } from '@tanstack/react-router'

import { RoleGate } from '@/components/guards'
import { InvoicingSettingsPage } from '@/pages/settings/organization/InvoicingSettingsPage'

export const Route = createFileRoute(
  '/_authenticated/_dashboard/settings/organization/invoicing/',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <RoleGate requires="ADMIN">
      <InvoicingSettingsPage />
    </RoleGate>
  )
}
